const URL = process.env.API_URL || "https://beta.jornada.com.mx/backend";

export const headers = {
  "Content-Type": "application/json",
};

export const NUM_ITEMS_PAGINATION = 15;

export default URL;
